import { BiDashboardGhost } from '@euler/app/components/message/widgets/bi-dashboard-changes/BiDashboardHostContext';
import { BiPreviewCardState } from '@euler/model/bi/change-set';
import { BiDraftView } from '@euler/model/bi/draft';
import { useServiceFactory } from '@euler/services/factory';
import { useLocalObservable } from '@euler/utils/hooks/useLocalObservable';
import { EMPTY, catchError, from, map, mergeMap, scan } from 'rxjs';

const kNone: ReadonlyMap<string, BiDraftView> = new Map();

/** The drafts the ghost adds as cards, read once per ghost. */
export function useBiGhostDrafts(
  ghost: BiDashboardGhost | null,
): ReadonlyMap<string, BiDraftView> {
  const { biService } = useServiceFactory();
  const wanted = (ghost?.preview.cards ?? [])
    .filter(card => card.state === BiPreviewCardState.Added && card.draftId)
    .map(card => card.draftId as string)
    .join(',');
  return useLocalObservable<ReadonlyMap<string, BiDraftView>>(
    () =>
      from(wanted ? wanted.split(',') : []).pipe(
        mergeMap(draftId =>
          from(biService.draft(draftId)).pipe(
            map(draft => [draftId, draft] as const),
            catchError(error => {
              console.error('BI ghost draft failed', draftId, error);
              return EMPTY;
            }),
          ),
        ),
        scan(
          (drafts: ReadonlyMap<string, BiDraftView>, [id, draft]) =>
            new Map(drafts).set(id, draft),
          kNone,
        ),
      ),
    kNone,
    [biService, wanted],
  );
}
